import * as React from 'react';

import classnames from 'classnames';

import {Line} from 'shells/divider/line';
import {CopyableLink} from 'shells/link/copyable-link';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';
import {MarketingTitle} from 'shells/typography/marketing-title';

import {Embedded} from '../../core/embedded';

import {CalendarSyncSettings} from './calendar-sync-settings';
import {GetCalendarSync} from './get-calendar-sync';

import styles from './calendar-page.module.css';

export function CalendarPage() {
    return (
        <GetCalendarSync>
            {/* @ts-expect-error */}
            {({
                isLoading,
                calendarSync,
                personalCalendarFeedUrl,
                companyCalendarFeedUrl,
                refetch,
                errorMessage,
            }) => {
                if (isLoading) {
                    return null;
                }

                const divider = calendarSync ? (
                    <div className={styles.divider}>
                        <Line />
                    </div>
                ) : (
                    <div className={styles.divider}>
                        <Line text='Or if you aren’t using Google or Office 365' />
                    </div>
                );

                return (
                    <div className={classnames('pad-16', styles['calendar-page'])}>
                        {/* @ts-expect-error */}
                        <Embedded
                            default={
                                <>
                                    <CalendarSyncSettings
                                        calendarSync={calendarSync}
                                        refetchSyncStatus={refetch}
                                        errorMessage={errorMessage}
                                    />
                                    {personalCalendarFeedUrl || companyCalendarFeedUrl ? (
                                        <React.Fragment>
                                            {divider}
                                            <MarketingTitle>
                                                Add Nutshell activities to your external calendar
                                                from a URL
                                            </MarketingTitle>
                                            <Body as='p'>
                                                Use these URLs to subscribe to activities made in
                                                Nutshell so that they’ll show up on your external
                                                calendar. You can subscribe to just your activities,
                                                or a feed of every activity in your company.{' '}
                                                <Link
                                                    href='https://support.nutshell.com/en/articles/8428907-add-nutshell-activities-to-your-external-calendar'
                                                    variant='primary'
                                                    newTab={true}
                                                    size='normal'
                                                >
                                                    Learn more about linking externals calendars
                                                </Link>
                                            </Body>
                                            <div className={styles['ics-links']}>
                                                {personalCalendarFeedUrl ? (
                                                    <CopyableLink
                                                        size='big'
                                                        name='PersonalCalendarFeed'
                                                        label='Personal calendar feed'
                                                        value={personalCalendarFeedUrl}
                                                    />
                                                ) : undefined}
                                                {companyCalendarFeedUrl ? (
                                                    <CopyableLink
                                                        size='big'
                                                        name='CompanyCalendarFeed'
                                                        label='Company calendar feed'
                                                        value={companyCalendarFeedUrl}
                                                    />
                                                ) : undefined}
                                            </div>
                                        </React.Fragment>
                                    ) : null}
                                </>
                            }
                            embedded={
                                <CalendarSyncSettings
                                    calendarSync={calendarSync}
                                    refetchSyncStatus={refetch}
                                    errorMessage={errorMessage}
                                    isEmbedded={true}
                                />
                            }
                        />
                    </div>
                );
            }}
        </GetCalendarSync>
    );
}
